import every from 'lodash/every';
import { Component, Input, OnInit } from '@angular/core';
import { ORDER_LINE_STATES } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'grouped-extra-product-tbody, tbody[grouped-extra-product-tbody]',
  templateUrl: './grouped-extra-product-tbody.component.html'
})
export class GroupedExtraProductTbodyComponent implements OnInit {
  @Input() orderLine: any;
  @Input() currency: string;
  @Input() simplifyView = false;

  public products: any;
  public hideContent = false;
  public ORDER_LINE_STATES = ORDER_LINE_STATES;

  ngOnInit(): void {
    this.hideContent = this._areLinesDeleted();
    this.products = this._mapOrderLineProducts(this.orderLine.products);
  }

  private _mapOrderLineProducts(products) {
    return products.map(p => {
      const price = p.price + p.discountAmount;
      const total = price * p.quantity;
      return { ...p, price, total };
    });
  }

  private _areLinesDeleted() {
    return every(this.orderLine.products, (product) => product.state === ORDER_LINE_STATES.DELETED);
  }
}
